import { Component, OnInit } from '@angular/core';
import { SymbolSearchService, SearchSymbolResults } from '@shared/providers';
import { UntypedFormControl } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-advance-symbol-search',
  templateUrl: './advance-symbol-search.component.html',
  styleUrls: ['./advance-symbol-search.component.scss']
})
export class AdvanceSymbolSearchComponent implements OnInit {
  searchCtrl = new UntypedFormControl();
  symbols: SearchSymbolResults[] = [];

  constructor(
    private symbolSearchService: SymbolSearchService,
    private dialogRef: MatDialogRef<AdvanceSymbolSearchComponent>
  ) { }

  ngOnInit(): void {
    this.searchCtrl.valueChanges.pipe(
      debounceTime(300)
    ).subscribe(value => {
      // Search indices too.
      this.symbols = this.symbolSearchService.search(value, false, true);
    });
  }

  add(symbol: SearchSymbolResults) {
    this.dialogRef.close(symbol);
  }
}
